import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { setConfigurationLoginModalOpen } from '../../../store/actions'
//import { updateSearchParameters } from '../../../store/actions/search'
import { logEvent } from '../../../utilities'
import { formatFileLink, trimFileLink } from '../../cdl-react-components/utilities/files'
import { WEBHOST_URL } from '../../cdl-react-components/utilities/constants'
import { CONTENT_MODE } from '../../../utilities/constants'

import RegionalMapDesktop from './RegionalMapDesktop'
import RegionalMapMobile from './RegionalMapMobile'
import { graphqlFetch } from '../../cdl-react-components/utilities'

const RegionalMap = (props) => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector(_ => _.data.user)
    const authenticated = useSelector(_ => _.data.authenticated)
    const contentMode = useSelector(_ => _.data.configuration.contentMode)
    const [regionalMap, setRegionalMap] = useState()

    useEffect(() => {
        fetchRegionalMap(id)
    }, [id])

    const login = () => dispatch(setConfigurationLoginModalOpen(true))

    const fetchRegionalMap = (regionalMapId) => {
        /* Updating the state in this function will cause another update to occur.
           As such this function will be called again causing an infinite loop.
           Only update the state if it needs to be updated. - rrogers 2018-07-05 */
        if (!regionalMap ||
            regionalMap.id !== parseInt(regionalMapId)
        ) {
            logEvent({ 'CDL_Map_Series_Viewed': regionalMapId })
            graphqlFetch('wcms3', `
                query {
                    regionalMaps (
                        where: { id: { eq: ${regionalMapId} } }
                    ) {
                        items {
                            coming_soon: comingSoon
                            description
                            has_purchasable_shapefile: hasPurchasableShapefile
                            id
                            image
                            map_type: contentRegionalmapMapTypes {
                                maptype {
                                    id
                                    name
                                }
                            }
                            pdf
                            pdf_size_field: pdfFileSize
                            private_description: privateDescription
                            private_image: privateImage
                            publication_date: publicationDate
                            published
                            sample_pdf: samplePdf
                            subtitle
                            title
                            zone_of_interest: zoneOfInterestId
                        }
                    }
                }`)
                .then(res => {
                    if (res.data.regionalMaps.items.length === 0)
                        return navigate('/') 
                    else {
                        const regionalMap = res.data.regionalMaps.items[0]
                        regionalMap.map_type = regionalMap.map_type?.map(x => x.maptype)

                        setRegionalMap(regionalMap)
                    }
                })
        }
    }

    const logMapOpened = () => new Promise(res => {
        logEvent({ 'CDL_Map_Series_Opened': regionalMap.id })
        res()
    }) 

    const buildPdfLocation = () => WEBHOST_URL + '/' + trimFileLink(regionalMap.pdf)
    const buildSamplePdfLocation = () => WEBHOST_URL + '/' + trimFileLink(regionalMap.sample_pdf)

    const getImage = (regionalMap, authenticated) => {
        const defaultImagePath = 'https://webfiles.canadiandiscovery.com/public/CDD/regionalMaps/images/default/'
        const defaultImages = {
            'Geochemistry': defaultImagePath + 'geochemistry.jpg',
            'Geomechanics': defaultImagePath + 'geomechanics.jpg',
            'Geothermics': defaultImagePath + 'geothermics.jpg',
            'Hydrodynamics': defaultImagePath + 'hydrodynamics.jpg'
        }

        const image = authenticated ?
            regionalMap.private_image :
            regionalMap.image

        return formatFileLink(image) || defaultImages[regionalMap.map_type[0].name]
    }

    return regionalMap ? (
        contentMode === CONTENT_MODE.MOBILE ?
            (<RegionalMapMobile
                regionalMap={regionalMap} 
                handleLogin={login} 
                authenticated={authenticated}
                user={user}
                link={buildPdfLocation()}
                sampleLink={buildSamplePdfLocation()} 
                getImage={getImage}
                logMapOpened={logMapOpened} />) :
            (<RegionalMapDesktop 
                regionalMap={regionalMap} 
                handleLogin={login} 
                authenticated={authenticated}
                user={user}
                link={buildPdfLocation()}
                sampleLink={buildSamplePdfLocation()} 
                getImage={getImage} 
                logMapOpened={logMapOpened} />)
    ): null
}

export default RegionalMap
